export function Footer() {
  return (
    <footer id="footer" className="bg-black text-white text-center py-4">
      <div className="container mx-auto px-4">
        <div id="copyright" className="text-sm">
          © 2026 Barret Precision Engines. All Rights Reserved. Tulsa, Oklahoma (918) 835-1089 Site By:{' '}
          <a 
            href="http://brooksidestudios.com/" 
            className="text-white hover:text-gray-300 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Brookside Studios
          </a>
        </div>
      </div>
    </footer>
  );
}